import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const photos = [{
  url: 'https://images.unsplash.com/photo-1577896851231-70ef18881754?auto=format&fit=crop&q=80&w=800',
  caption: 'Repertorio del acto, listo en segundos'
}, {
  url: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?auto=format&fit=crop&q=80&w=800',
  caption: 'Clase ordenada, del primer al último minuto'
}, {
  url: 'https://images.unsplash.com/photo-1511379938547-c1f69419868d?auto=format&fit=crop&q=80&w=800',
  caption: 'Ensamble afinado, sin ensayos de más'
}, {
  url: 'https://images.unsplash.com/photo-1588072432836-e10032774350?auto=format&fit=crop&q=80&w=800',
  caption: 'Alumnos motivados con canciones que conocen'
}, {
  url: 'https://images.unsplash.com/photo-1509062522246-3755977927d7?auto=format&fit=crop&q=80&w=800',
  caption: 'Planificación anual resuelta en marzo'
}];
export function Gallery() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const next = () => setCurrentIndex(prev => (prev + 1) % photos.length);
  const prev = () => setCurrentIndex(prev => (prev - 1 + photos.length) % photos.length);
  return <section className="bg-white text-navy py-12 overflow-hidden" data-id="element-80">
      <div className="max-w-md mx-auto px-4" data-id="element-81">
        <h2 className="text-center text-sm font-bold text-violet mb-6 uppercase tracking-wider" data-id="element-82">
          Así se sienten las clases cuando ya no improvisás
        </h2>

        <div className="relative rounded-2xl overflow-hidden shadow-xl bg-gray-100" data-id="element-83">
          <div className="relative h-[280px] w-full" data-id="element-84">
            <AnimatePresence mode="wait" data-id="element-85">
              <motion.img key={currentIndex} src={photos[currentIndex].url} alt={photos[currentIndex].caption} className="absolute inset-0 w-full h-full object-cover" initial={{
              opacity: 0,
              x: 50
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -50
            }} transition={{
              duration: 0.3
            }} data-id="element-86" />
            </AnimatePresence>

            {/* Gradient overlay for text readability */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" data-id="element-87" />

            <div className="absolute bottom-0 left-0 right-0 p-4 text-white" data-id="element-88">
              <p className="font-medium text-center text-[15px] shadow-sm" data-id="element-89">
                "{photos[currentIndex].caption}"
              </p>
            </div>

            {/* Navigation Arrows */}
            <button onClick={prev} className="absolute left-2 top-1/2 -translate-y-1/2 w-10 h-10 bg-white/30 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-white/50 transition-colors" data-id="element-90">
              <ChevronLeft className="w-6 h-6" data-id="element-91" />
            </button>
            <button onClick={next} className="absolute right-2 top-1/2 -translate-y-1/2 w-10 h-10 bg-white/30 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-white/50 transition-colors" data-id="element-92">
              <ChevronRight className="w-6 h-6" data-id="element-93" />
            </button>
          </div>
        </div>

        {/* Dots */}
        <div className="flex justify-center gap-2 mt-4" data-id="element-94">
          {photos.map((_, idx) => <button key={idx} onClick={() => setCurrentIndex(idx)} className={`w-2 h-2 rounded-full transition-colors ${idx === currentIndex ? 'bg-violet' : 'bg-gray-300'}`} data-id="element-95" />)}
        </div>
      </div>
    </section>;
}